/* istanbul ignore file */
import React, { useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import {
  Box,
  TextField,
  FormControl,
  FormHelperText,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Dialog, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';
import { StyledDialogActions } from 'containers/ExpertExpertise/Dialogs/styles';
import messages from 'containers/IntervenantManagement/messages';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';

export interface AddLawyerFormProps {
  intl: IntlShape;
  lawyerOptions: any;
  onClose: Function;
  open: boolean;
  disabled: boolean;
  requestCreateIntervenantKeycloak: Function;
}
const AddIntervenantDialog = (props: AddLawyerFormProps) => {
  const [error] = useState<string>('');
  const [selectedLawyer, setSelectedLawyer] = useState<any | null>(null);
  const [lastName, setLastName] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState<string>('');
  const handleLawyerChange = (event: any, newValue: any | null) => {
    setSelectedLawyer(newValue);

    if (newValue) {
      const nameParts = newValue.ItemDescription.trim().split(' ');
      if (nameParts.length >= 2) {
        const middleIndex = Math.floor(nameParts.length / 2);

        const last = nameParts.slice(0, middleIndex).join(' ');

        const first = nameParts.slice(middleIndex).join(' ');

        setLastName(last);
        setFirstName(first);
        setUsername(
          newValue.ItemDescription.trim()
            .replace(/\s+/g, '-')
            .toLowerCase(),
        );
      } else {
        setLastName(newValue.ItemDescription.trim());
        setUsername(newValue.ItemDescription.trim().toLowerCase());
        setFirstName('');
      }
    } else {
      setFirstName('');
      setLastName('');
      setUsername('');
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const successCallBackAddIntervenant = () => {
    props.onClose();
    toast.success(translate(messages.toastIntervenantTitle, props));
  };
  const hanldeValidate = () => {
    props.requestCreateIntervenantKeycloak(
      {
        username: username,
        firstName: firstName,
        lastName: lastName,
        password: password,
        sagis_code: selectedLawyer.ItemKey,
      },
      successCallBackAddIntervenant,
    );
  };

  return (
    <Dialog
      onClose={/* istanbul ignore next */ () => props.onClose()}
      aria-labelledby="simple-dialog-title"
      open={props.open}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid container direction="row" spacing={3}>
          <Grid item xs={11}>
            {'Ajouter un intervenant'}
          </Grid>
          <Grid item>
            <CloseIconBlack onClick={() => props.onClose()} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ width: '600px' }}>
        <Box
          component="form"
          id="add-lawyer-form"
          display="flex"
          flexDirection="column"
          style={{ gap: 24, padding: '20px' }}
        >
          <FormControl fullWidth>
            <Autocomplete
              options={props.lawyerOptions}
              getOptionLabel={(option: any) =>
                `${option.ItemDescription} — ${option.address}`
              }
              onChange={handleLawyerChange}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Avocat"
                  placeholder="Sélectionnez un avocat"
                />
              )}
              renderOption={option => (
                <Box display="flex" flexDirection="column">
                  <strong>{option.ItemDescription}</strong>
                  <small style={{ color: '#666' }}>{option.address}</small>
                </Box>
              )}
              style={{ marginBottom: 16 }}
            />
            {error && <FormHelperText error>{error}</FormHelperText>}
          </FormControl>

          {selectedLawyer && (
            <>
              <FormControl fullWidth>
                <TextField
                  label="Nom"
                  value={lastName}
                  onChange={e => setLastName(e.target.value)}
                  required
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  label="Prénom"
                  value={firstName}
                  onChange={e => setFirstName(e.target.value)}
                  required
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  label="Nom d'utilisateur"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  required
                  helperText="Le nom d'utilisateur est généré automatiquement mais peut être modifié"
                />
              </FormControl>
            </>
          )}

          <FormControl fullWidth>
            <TextField
              label="Mot de passe"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Box>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testid="cancel-button"
          title={translate({ ...messages.dialogCancelButton }, props)}
        />
        <PrimaryButton
          onClick={hanldeValidate}
          disableElevation
          data-testid="validate-button"
          title={translate({ ...messages.dialogValidationButton }, props)}
          disabled={props.disabled}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

export default injectIntl(AddIntervenantDialog);
